"use client";

import {useTranslation} from "react-i18next";

/** A proposal field's label; fields without one read as their API name, split into words. */
export default function ProposalFieldLabel({field}: {field: string}) {
   const {t, i18n} = useTranslation("ask");
   const key = `toolApproval.fields.${field}`;
   return <>{i18n.exists(key, {ns: "ask"}) ? t(key) : t("toolApproval.otherField", {name: field.replace(/([a-z])([A-Z])/g, "$1 $2")})}</>;
}
